// API 베이스 URL 해석
//
// ─ 개발 서버(yarn start:*)   : 항상 "/proxy-api" (상대경로) 를 쓴다.
//                              src/setupProxy.js 가 PROXY_TARGET(local/dev/prod) 으로 서버사이드 프록시하므로
//                              브라우저는 same-origin(localhost:3000) 으로만 통신 → 게이트웨이 CORS 와 무관.
// ─ 프로덕션 빌드(yarn build) : 실제 백엔드 절대 URL 을 쓴다.
//                              Vercel 대시보드 환경변수 REACT_APP_BASE_OWNER_URL 이 최우선, 없으면 prod 로 fallback.
//
// 환경 전환은 package.json 스크립트로 한다: yarn start:local | start:dev | start:prod
// WebSocket URL 은 shared/lib/socket/websocket.ts 에서 BASE_OWNER_URL 의 http→ws 치환으로 파생한다.

const DEV_PROXY_PREFIX = "/proxy-api";
const PROD_FALLBACK = "https://api.ridefload.com";

const isDev = process.env.NODE_ENV === "development";

/** 현재 바라보는 환경 라벨 (스크립트의 REACT_APP_API_ENV, 표시·디버깅용) */
export const API_ENV = process.env.REACT_APP_API_ENV || (isDev ? "dev-proxy" : "prod");

export const BASE_OWNER_URL = isDev
    ? DEV_PROXY_PREFIX
    : process.env.REACT_APP_BASE_OWNER_URL || PROD_FALLBACK;

// 소켓 URL 은 websocket.ts 에서 BASE_OWNER_URL 로부터 파생하므로 사실상 미사용. 호환용으로만 유지.
export const BASE_SOCKET_URL = BASE_OWNER_URL;

// 개발 중 현재 어떤 백엔드에 붙어있는지 콘솔로 확인 (프로덕션 빌드에서는 transform-remove-console 로 제거됨).
console.info(
    `[API] env=${API_ENV} · baseURL=${BASE_OWNER_URL}` +
        (isDev ? "  (실제 프록시 대상은 터미널의 [proxy] 로그 참고)" : "")
);
